












































// @ is an alias to /src
import { Component, Vue, Watch } from 'vue-property-decorator'
import apiPartenaire from '@/api/partenaire'
import { toSubArray } from '@/utils/groupBy'
import ReadFtp from '@/components/partenaire/read/ReadFtp.vue'
import ReadParamCw from '@/components/partenaire/read/ReadParamCw.vue'
import ReadConfig from '@/components/partenaire/read/ReadConfig.vue'
import ReadFlux from '@/components/partenaire/read/ReadFlux.vue'
import { AloPartenaire, getDefaultAloPartenaire } from '@/models/alo/AloPartenaire'
import { PartRestrictFlag } from '@/enum/PartRestrictFlag'


@Component({
  name: 'ModifyPartenaires', 
  props: {
    partenaireId:Number 
  },
  components: {ReadFtp, ReadConfig, ReadFlux,ReadParamCw },
})

export default class ModifyPartenaires extends Vue {
  partenaireId!: number
  private showError = false    
  private loading = false

  get restrictedFlag(){ return this.partenaire.ptnRestrictedFlag.split(', ')}  
  get isCentralWeb() {return this.$store.myGetters.isCentralWeb}
  get noRestrict() {return this.isCentralWeb && this.noRestrictIfCentralWeb}
  
  get noRestrictIfCentralWeb() { return this.restrictedFlag.some(it => it == PartRestrictFlag.noRestrictIfCentralWeb)}
  get noSave() { return !this.noRestrict &&  this.restrictedFlag.some(it => it == PartRestrictFlag.noSave)}
  get noRemove() { return !this.noRestrict && this.restrictedFlag.some(it => it == PartRestrictFlag.noRemove)}
  get noChangePassword() { return !this.noRestrict && (this.noDisplayPassword || this.noSave || this.restrictedFlag.some(it => it == PartRestrictFlag.noChangePassword))}
  get noChangePriority() { return !this.noRestrict && (this.noDisplayPriority || this.noSave || this.restrictedFlag.some(it => it == PartRestrictFlag.noChangePriority))}
  get noChangeEnable() { return !this.noRestrict && (this.noSave || this.restrictedFlag.some(it => it == PartRestrictFlag.noChangeEnable))}
  get noChangeFlx() { return !this.noRestrict && (this.noSave || this.restrictedFlag.some(it => it == PartRestrictFlag.noChangeFlx))}
  get noDisplayLogin() { return !this.noRestrict && this.restrictedFlag.some(it => it == PartRestrictFlag.noDisplayLogin)}
  get noDisplayPassword() { return !this.noRestrict && this.restrictedFlag.some(it => it == PartRestrictFlag.noDisplayPassword)}
  get noDisplayPriority() { return !this.noRestrict && this.restrictedFlag.some(it => it == PartRestrictFlag.noDisplayPriority)}
  get noDisplayEnable() { return !this.noRestrict && this.restrictedFlag.some(it => it == PartRestrictFlag.noDisplayEnable)}
  get noDisplayFlx() { return !this.noRestrict && this.restrictedFlag.some(it => it == PartRestrictFlag.noDisplayFlx)}
  get noDisplayFtpAccess() { return !this.noRestrict && this.restrictedFlag.some(it => it == PartRestrictFlag.noDisplayFtpAccess)}
  

  get partenaire(){
    return this.$store.myGetters.partenaire[this.partenaireId] || getDefaultAloPartenaire()
  }

  loadPartenaire() {    
    this.loading = true    
    this.$store.myActions.ADM_PARTENAIRE_DETAIL_REQUEST(this.partenaireId).finally(() => {
      this.loading = false
    })    
  }

  @Watch('partenaireId')
  onPartenaireIdChanged(){
   this.loadPartenaire()
  }

  created(){
    this.$store.myActions.ADM_FLUX_ENSURE().then(() =>{
      this.loadPartenaire()
    })    
  }
  
  get arianeItems() { 
    const arianeItems =  [
        {
          text: 'Partenaires',
          disabled: false,          
          to: {name:'Partenaires'},
          exact:true
        }
      ]
    if(this.partenaire) {
        arianeItems.push({
          text: this.partenaire.libelle,
          disabled: true,          
          to: {name:''},
          exact:true
        })
    }
    return arianeItems;
  } 

  remove(){
     this.$confirm(`Etes vous sûr de vouloir supprimer le partenaire '${this.partenaire.libelle}'`).then((answer)=>{
      if(answer){
        this.$store.myActions.ADM_PARTENAIRE_DELETE_REQUEST(this.partenaire.id).then(()=>{
          this.$router.push({name:'Partenaires'})
        })
      }
    })
  }

}
